import React from 'react';

export default function FooterBar() {
  return (
    <footer className="border-t border-white/10 px-4 py-6 text-center text-xs uppercase tracking-[0.14em] text-slate-500 sm:px-6 lg:px-10">
      © {new Date().getFullYear()} Prathmesh Bondar. Crafted with precision.
    </footer>
  );
}
